import { render, staticRenderFns } from "./WorkChangeHistoryList.vue?vue&type=template&id=b0c4971a&scoped=true"
import script from "./WorkChangeHistoryList.vue?vue&type=script&lang=js"
export * from "./WorkChangeHistoryList.vue?vue&type=script&lang=js"
import style0 from "./WorkChangeHistoryList.vue?vue&type=style&index=0&id=b0c4971a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c4971a",
  null
  
)

export default component.exports